import { render } from "./CallbackPopup.vue?vue&type=template&id=aede2622&scoped=true"
import script from "./CallbackPopup.vue?vue&type=script&lang=js"
export * from "./CallbackPopup.vue?vue&type=script&lang=js"

import "./CallbackPopup.vue?vue&type=style&index=0&id=aede2622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aede2622"]])

export default __exports__